import { Buildings } from "@phosphor-icons/react";
import LegalLayout, { Section, P } from "@/components/LegalLayout";

export default function LegalNotice() {
  return (
    <LegalLayout
      eyebrow="Mentions légales"
      icon={Buildings}
      title="Qui édite ce service ?"
      intro="Conformément aux dispositions de l'article 6-III de la loi n° 2004-575 du 21 juin 2004 pour la confiance dans l'économie numérique, nous mettons à disposition des utilisateurs les informations suivantes."
      path="/mentions-legales"
    >
      <Section title="Éditeur du site">
        <ul className="space-y-1.5">
          <li><strong>Raison sociale</strong> : <P /></li>
          <li><strong>Forme juridique</strong> : <P /></li>
          <li><strong>Capital social</strong> : <P /></li>
          <li><strong>Adresse du siège social</strong> : <P /></li>
          <li><strong>SIRET</strong> : <P /></li>
          <li><strong>RCS</strong> : <P /></li>
          <li><strong>N° TVA intracommunautaire</strong> : <P /></li>
          <li><strong>Directeur de la publication</strong> : <P /></li>
          <li><strong>Email de contact</strong> : <a href="mailto:contact@questiomed.fr" className="text-[#3A8FA5] underline underline-offset-2">contact@questiomed.fr</a></li>
          <li><strong>Téléphone</strong> : <P /></li>
        </ul>
      </Section>

      <Section title="Nom commercial et marque">
        <p>
          Le service est exploité sous le nom commercial <strong>Questiomed</strong>. La marque, le logo,
          les identifiants graphiques et la charte associée sont la propriété exclusive de l'éditeur.
        </p>
      </Section>

      <Section title="Activité et cadre réglementaire">
        <p>
          Questiomed est un logiciel en ligne (SaaS) destiné aux professionnels de santé pour la création,
          l'envoi et l'exploitation de questionnaires cliniques. L'éditeur n'exerce pas d'activité médicale
          et n'intervient pas dans la relation de soin entre le praticien et son patient.
        </p>
        <p>
          Le service traite des données de santé au sens de l'article 4-15 du RGPD et de l'article
          L. 1111-8 du Code de la santé publique. L'hébergement est assuré par un tiers certifié HDS
          (Hébergeur de Données de Santé — référentiel HDS 2018).
        </p>
      </Section>

      <Section title="Hébergement">
        <ul className="space-y-1.5">
          <li><strong>Hébergeur</strong> : <P /></li>
          <li><strong>Adresse</strong> : <P /></li>
          <li><strong>Certification HDS</strong> : <P label="N° DE CERTIFICAT HDS À COMPLÉTER" /></li>
          <li><strong>Localisation des serveurs</strong> : France / Union européenne</li>
        </ul>
      </Section>

      <Section title="Protection des données personnelles">
        <ul className="space-y-1.5">
          <li><strong>Délégué à la protection des données (DPO)</strong> : <P label="NOM DU DPO À COMPLÉTER" /></li>
          <li><strong>Contact DPO</strong> : <a href="mailto:dpo@questiomed.fr" className="text-[#3A8FA5] underline underline-offset-2">dpo@questiomed.fr</a></li>
          <li><strong>Numéro d'inscription CNIL / traitement</strong> : <P label="À COMPLÉTER — TRAITEMENT DOCUMENTÉ RGPD ART. 30" /></li>
          <li><strong>Autorité de contrôle</strong> : Commission Nationale de l'Informatique et des Libertés (CNIL), 3 place de Fontenoy, TSA 80715, 75334 Paris Cedex 07 — <a href="https://www.cnil.fr" target="_blank" rel="noreferrer" className="text-[#3A8FA5] underline underline-offset-2">cnil.fr</a></li>
        </ul>
        <p>
          Pour toute demande relative à vos données personnelles, consultez notre <a href="/confidentialite" className="text-[#3A8FA5] underline underline-offset-2">politique de confidentialité</a>.
        </p>
      </Section>

      <Section title="Propriété intellectuelle">
        <p>
          L'ensemble des éléments du service (interfaces, textes, illustrations, code source, base de
          questionnaires validés, algorithmes de scoring) est protégé par le Code de la propriété
          intellectuelle. Toute reproduction, représentation ou exploitation totale ou partielle sans
          autorisation écrite préalable de l'éditeur est interdite.
        </p>
        <p>
          Les questionnaires validés proposés dans la bibliothèque sont diffusés dans le respect de
          leurs conditions d'utilisation respectives (domaine public, licence libre avec attribution, etc.).
          Les questionnaires personnalisés créés par un praticien lui appartiennent.
        </p>
      </Section>

      <Section title="Crédits">
        <p>
          Design et développement : équipe Questiomed. Icônes : Phosphor Icons (MIT). Typographie :
          Manrope (Google Fonts, OFL 1.1).
        </p>
      </Section>

      <Section title="Signaler un contenu / une atteinte">
        <p>
          Toute demande de retrait, réclamation ou signalement peut être adressée par courriel à
          <a href="mailto:contact@questiomed.fr" className="text-[#3A8FA5] underline underline-offset-2 ml-1">contact@questiomed.fr</a>
          {" "}ou par courrier postal à l'adresse du siège social indiquée ci-dessus.
        </p>
      </Section>
    </LegalLayout>
  );
}
